/**
 * In-memory cache for institutional Budget retrieve payloads (`GET /budgets/{id}/`).
 * Used by `getBudgetLineLazy` so hover/open does not repeat the same request.
 */

class BudgetCache {
  static cache = new Map();
  static cacheTimeout = 5 * 60 * 1000; // 5 minutes

  static key(id) {
    return id == null ? null : String(id);
  }

  /**
   * @param {string|number} id
   * @returns {Object|null}
   */
  static get(id) {
    const key = this.key(id);
    if (key == null) return null;
    const cached = this.cache.get(key);
    if (!cached) return null;
    if (Date.now() - cached.timestamp > this.cacheTimeout) {
      this.cache.delete(key);
      return null;
    }
    return cached.data;
  }

  /**
   * @param {string|number} id
   * @param {Object} data
   */
  static set(id, data) {
    const key = this.key(id);
    if (key == null || data == null) return;
    this.cache.set(key, { data, timestamp: Date.now() });
  }

  /**
   * @param {string|number} id
   */
  static remove(id) {
    const key = this.key(id);
    if (key == null) return;
    this.cache.delete(key);
  }

  static clear() {
    this.cache.clear();
  }
}

export default BudgetCache;
